const firebaseConfig = {
    apiKey: "AIzaSyALH-xxXxw3GB8hM4Bm1PZLRHQzBqXkuhI",
    authDomain: "shakil-007.firebaseapp.com",
    databaseURL: "https://shakil-007.firebaseio.com",
    projectId: "shakil-007",
    storageBucket: "shakil-007.appspot.com",
    messagingSenderId: "228456670253",
    appId: "1:228456670253:web:ab196d8ba2c371398884a4"
  };

  export default firebaseConfig;